export default __webpack_public_path__ + "static/media/fuse-solana-skewed.a7656619.png";